import NP from 'nprogress'

const postGuard = function (): any {
  NP.done()
}

export default postGuard
